/**Describes possible app element asset types */
export enum AppElementAssetTypes {
    // eslint-disable-next-line prettier/prettier
    image = 0,
    video,
    audio,
    archive,
    generic
}